var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "well well-no-shadow clearfix" },
    [
      _c("preloader", { attrs: { display: _vm.loading } }),
      _vm._v(" "),
      _c("h2", { staticClass: "mt-0" }, [
        _vm._v(
          _vm._s(
            _vm.$l10n.__("Préférences Générales de l'annuaire des sociétés")
          )
        )
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "prefForm",
          attrs: {
            model: _vm.prefForm,
            rules: _vm.rules,
            "label-position": "top"
          }
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t.__(
                  "companysearch.CompanySearchPrefForm.authorized_countries_for_search"
                ),
                prop: "countriesAuthorize"
              }
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "wp-3",
                  attrs: {
                    multiple: "",
                    placeholder: _vm.$t.__(
                      "companysearch.CompanySearchPrefForm.select_country"
                    )
                  },
                  on: { "remove-tag": _vm.resetDefault },
                  model: {
                    value: _vm.prefForm.countriesAuthorize,
                    callback: function($$v) {
                      _vm.$set(_vm.prefForm, "countriesAuthorize", $$v)
                    },
                    expression: "prefForm.countriesAuthorize"
                  }
                },
                _vm._l(_vm.countriesAvailable, function(country) {
                  return _c("el-option", {
                    key: country,
                    attrs: {
                      label: _vm.getCountryLabel(country),
                      value: country
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t.__(
                  "companysearch.CompanySearchPrefForm.default_country_search"
                ),
                prop: "countryDefault"
              }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: _vm.$t.__(
                      "companysearch.CompanySearchPrefForm.select_default_country"
                    )
                  },
                  model: {
                    value: _vm.prefForm.countryDefault,
                    callback: function($$v) {
                      _vm.$set(_vm.prefForm, "countryDefault", $$v)
                    },
                    expression: "prefForm.countryDefault"
                  }
                },
                _vm._l(_vm.prefForm.countriesAuthorize, function(country) {
                  return _c("el-option", {
                    key: country,
                    attrs: {
                      label: _vm.getCountryLabel(country),
                      value: country
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "aleft mt-6" },
            [
              _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__(
                    "companysearch.CompanySearchPrefForm.save_modifications"
                  ),
                  type: "primary"
                },
                on: {
                  click: function($event) {
                    return _vm.submitForm("prefForm")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }